<script>
    export default {
        name: "GiftLabel",
        props: {
            isMobile: Boolean,
        },
    };
</script>

<template>
    <div class="gift-label" :class="{ 'gift-label--mobile': isMobile }">
        <span v-if="isMobile" class="gift-label__text">Тариф Cloud&nbsp;5</span>
        <template v-else>
            <span class="gift-label__text desktop-hidden">Тариф Cloud&nbsp;5</span>
            <span class="gift-label__text mobile-hidden">
                <span>Подписка Cloud&nbsp;5</span>
                <span>в&nbsp;подарок</span>
            </span>
        </template>
    </div>
</template>

<style lang="scss">
    .gift-label {
        position: absolute;
        top: 4px;
        left: 4px;
        z-index: 10;
        width: 100px;
        height: 28px;
        background-color: #7975dd;
        border-radius: 10px;
        overflow: hidden;
        transition: width 0.2s ease-in;
        @include bp($bp-desktop-sm) {
            top: 12px;
            left: 12px;
            border-radius: 16px;
            @include box(44px);
            &:hover {
                width: 180px;
            }
        }

        &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: 6px;
            @include box(14px);
            margin: 0 auto;
            background-image: url("/static/ivideon/icons/gift.svg");
            background-size: contain;
            transform: translateY(-50%);
            @include bp($bp-desktop-sm) {
                left: 10px;
                @include box(24px);
            }
        }
    }

    .gift-label--mobile {
        @include bp($bp-desktop-sm) {
            @include box(38px);
            &:hover {
                width: 150px;
            }
            &::before {
                left: 9px;
                @include box(20px);
                background-image: url("/static/ivideon/icons/gift.svg");
            }
            .gift-label__text {
                left: 40px;
            }
        }
    }

    .gift-label__text {
        position: absolute;
        top: 50%;
        left: 23px;
        color: #ffffff;
        font-size: 10px;
        line-height: 10px;
        white-space: nowrap;
        transform: translateY(-50%);
        @include bp($bp-desktop-sm) {
            left: 44px;
            min-width: 110px;
            font-size: 14px;
            line-height: 14px;
            white-space: normal;
            span {
                display: block;
                white-space: nowrap;
            }
        }
    }
</style>
